import { Heading } from '@simplywallst/ui-core';
import type { ReactNode } from 'react';

interface RiskRewardHeadingProps {
  children: ReactNode;
}
function RiskRewardHeading({ children }: RiskRewardHeadingProps) {
  if (!children) return null;
  return (
    <Heading
      as="h3"
      typography="xSmall"
      color="whiteRGBA"
      opacity={0.7}
      lineClamp={3}
      textTransform="uppercase"
    >
      {children}
    </Heading>
  );
}

export default RiskRewardHeading;
